import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scan-modal-manual-input" }

import { ref, nextTick } from "vue";

// template refs

export default /*#__PURE__*/_defineComponent({
  emits: ["manualCodeSubmitted"],
  setup(__props, { expose, emit }: { emit: ({ (event: "manualCodeSubmitted", code: string): void }), expose: any, slots: any, attrs: any }) {

const input = ref();

// events


// state
const manualCode = ref<string>("");

// methods
const submit = (e: Event) => {
  e.preventDefault();
  //prevent empty codes to be submitted
  if(manualCode.value) emit("manualCodeSubmitted", manualCode.value);
};

const focusInput = () => {
  nextTick(() => input.value.$el.focus());
}

expose({
  focusInput,
});

return (_ctx: any,_cache: any) => {
  const _component_app_input = _resolveComponent("app-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "scan-modal-manual-input__form m-12",
      onSubmit: submit
    }, [
      _createVNode(_component_app_input, {
        ref_key: "input",
        ref: input,
        modelValue: manualCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((manualCode).value = $event)),
        type: "label",
        label: "",
        class: "iw-body-text-small scan-modal-manual-input__icon",
        placeholder: "Enter Barcode Manually"
      }, null, 8, ["modelValue"])
    ], 32)
  ]))
}
}

})